module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/rv2.webp";